import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ShopSnackbarService } from '@x/ecommerce-shop/app/core/shop-snackbar/shop-snackbar.service';
import { SnackbarUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/snackbar-ui/snackbar-ui.module';

@NgModule({
  providers: [MatSnackBar, ShopSnackbarService],
  imports: [CommonModule, SnackbarUiModule],
})
export class ShopSnackbarModule {}
